import script from "./tab-item.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-item.vue?vue&type=script&setup=true&lang=js"

import "./tab-item.vue?vue&type=style&index=0&id=030ba27f&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-030ba27f"]])

export default __exports__